import { instance } from './index';

//캠페인 목록 조회
function listCampaign(queries) {
  return instance.get('api/campaigns', queries);
}

//캠페인 추가
function createCampaign(data) {
  return instance.post('api/campaigns', data);
}

//캠페인  상세
function detailCampaign(campaignId) {
  return instance.get(`api/campaigns/${campaignId}`);
}

//캠페인 수정
function updateCampaign(campaignId, data) {
  return instance.put(`api/campaigns/${campaignId}`, data);
}

//캠페인이 추가될 수 있는 지면의 목록(이미 추가되지 않은 지면만 리턴)
function getListCampaignInventory(campaignId, data) {
  return instance.get(`api/campaigns/${campaignId}/inventories`, data);
}

//캠페인에 추가할 지면의 목록 저장
function addCampaignInventory(campaignId, data) {
  return instance.post(`api/campaigns/${campaignId}/inventories`, data);
}

//캠페인 내 해당 지면에 등록된 모든 라인아이템의 목록
function getListCampaignLineItems(campaignId, inventoryId) {
  return instance.get(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems`,
  );
}

//캠페인 내 해당 지면에 등록된 모든 라인아이템 제거
function deleteCampaignLineItems(campaignId, inventoryId) {
  return instance.delete(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems`,
  );
}

//캠페인 내 해당 지면에 등록된 라인아이템의 개별 정보 조회 (소재포함)
function getDetailCampaignLineItem(campaignId, inventoryId, lineItemId) {
  return instance.get(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems/${lineItemId}`,
  );
}

//캠페인 내 해당 지면에 등록된 라인아이템의 수정
function updateDetailCampaignLineItem(
  campaignId,
  inventoryId,
  lineItemId,
  data,
) {
  return instance.put(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems/${lineItemId}`,
    data,
  );
}

//캠페인 내 해당 지면에 등록된 라인아이템의 삭제
function deleteDetailCampaignLineItem(campaignId, inventoryId, lineItemId) {
  return instance.delete(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems/${lineItemId}`,
  );
}

//캠페인 내 해당 지면에 등록된 라인아이템 내 옵션 아이템 추가
function addOptionItem(campaignId, inventoryId, lineItemId, data) {
  return instance.post(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems/${lineItemId}/lris`,
    data,
  );
}

//캠페인 내 해당 지면에 등록된 라인아이템 내 옵션 아이템 수정
function updateOptionItem(campaignId, inventoryId, lineItemId, lriId, data) {
  return instance.put(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems/${lineItemId}/lris/${lriId}`,
    data,
  );
}

//캠페인 내 해당 지면에 등록된 라인아이템 내 옵션 아이템의 lris에 소재 추가
function addResource(campaignId, inventoryId, lineItemId, lriId, data) {
  return instance.post(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems/${lineItemId}/lris/${lriId}/resources`,
    data,
  );
}

//캠페인 내 해당 지면에 등록된 라인아이템 내 옵션 아이템의 lris에 소재 추가
function updateResource(
  campaignId,
  inventoryId,
  lineItemId,
  lriId,
  resourceId,
  data,
) {
  return instance.put(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems/${lineItemId}/lris/${lriId}/resources/${resourceId}`,
    data,
  );
}

//캠페인 내 해당 지면에 등록된 라인아이템 내 옵션 아이템의 lris에 소재 추가
function deleteResource(
  campaignId,
  inventoryId,
  lineItemId,
  lriId,
  resourceId,
) {
  return instance.delete(
    `api/campaigns/${campaignId}/inventories/${inventoryId}/lineitems/${lineItemId}/lris/${lriId}/resources/${resourceId}`,
  );
}

export {
  listCampaign,
  detailCampaign,
  createCampaign,
  updateCampaign,
  getListCampaignInventory,
  addCampaignInventory,
  deleteCampaignLineItems,
  getListCampaignLineItems,
  getDetailCampaignLineItem,
  updateDetailCampaignLineItem,
  deleteDetailCampaignLineItem,
  addOptionItem,
  updateOptionItem,
  addResource,
  updateResource,
  deleteResource,
};
